import { render } from "./Portfolio.vue?vue&type=template&id=45144532&scoped=true&ts=true"
import script from "./Portfolio.vue?vue&type=script&lang=ts"
export * from "./Portfolio.vue?vue&type=script&lang=ts"

import "./Portfolio.vue?vue&type=style&index=0&id=45144532&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45144532"]])

export default __exports__